module.exports = __webpack_public_path__ + "img/btn.6a8637a0.jpg";